// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iHT2","colBig":"styles_colBig__2rlPR","colSmall":"styles_colSmall__W_Uz6","shopifyNameWrapper":"styles_shopifyNameWrapper__3_LLs"};